import colors from '@rategravity/frontend/theme/colors';
import Paper from 'material-ui/Paper';
import React from 'react';
import { OwnUpLogoNoBackdrop } from '../../shared/icons';
import PhoneNumber from './phone-number';

const style = {
  container: {
    position: 'fixed',
    width: '100%',
    zIndex: 100,
    boxShadow: 'unset',
    borderBottom: '1px solid #DBE1E1'
  },
  menu: {
    padding: '0px 16px',
    backgroundColor: colors.white,
    color: colors.primary,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 60
  },
  logo: {
    height: '28px'
  },
  text: {
    fontSize: '13px',
    marginLeft: '4px'
  },
  icon: {
    height: '30px',
    color: 'inherit',
    verticalAlign: 'middle',
    transition: 'none'
  },
  status: {
    fontFamily: 'Graphik-Regular',
    fontSize: 13,
    letterSpacing: '0.003em'
  }
};

const HomeLink = () => (
  <a className="link" href="https://www.ownup.com">
    <OwnUpLogoNoBackdrop style={style.logo} />
  </a>
);

const HeaderPaper = ({ children }) => (
  <Paper style={style.container} zDepth={2} rounded={false} transitionEnabled={false}>
    {children}
  </Paper>
);

const Container = ({ children }) => {
  return (
    <div style={{ height: 60 }}>
      <HeaderPaper>{children}</HeaderPaper>
    </div>
  );
};

const Header = ({ scenario, status = '' }) => (
  <Container scenario={scenario}>
    <div style={style.menu}>
      <HomeLink />
      <div style={style.status}>{status}</div>
      <div>
        <PhoneNumber />
      </div>
    </div>
  </Container>
);

export const AnonHeader = (props) => <Header {...props} />;



// WEBPACK FOOTER //
// ./src/components/header/index.js